import OAuth from "../constants/OAuth2";

export default function cookieAndLocalStorage(){
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

    }
    if (window && window.localStorage) {
        localStorage.clear();
    }
    window.location = `${OAuth.dakikaUrl}/payroll/logout.xhtml`
}



// WEBPACK FOOTER //
// ./src/helpers/cookieAndLocalStorage.js